import { render } from "./PLogin.vue?vue&type=template&id=4c657381&scoped=true"
import script from "./PLogin.vue?vue&type=script&lang=js"
export * from "./PLogin.vue?vue&type=script&lang=js"

import "./PLogin.vue?vue&type=style&index=0&id=4c657381&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c657381"]])

export default __exports__